export default `
§ uiKit.console.button: 副本
§ uiKit.console.notification: 文本已被复制
§ uiKit.dataLoader.page: 页面
§ uiKit.dataLoader.size: 显示的
§ uiKit.dataLoader.rows: lines.
§ uiKit.dataLoader.from: 从
§ uiKit.dataLoader.all: 全部展示
§ uiKit.hoursChart.work: 标准工作时间 (平日07:00～20:00)
§ uiKit.hoursChart.weekend: 工作日之前/之后的休息日或时间
§ uiKit.hoursChart.days: 特定日期和小时内所有时间的提交总数
§ uiKit.page.remove: 移走
§ uiKit.nothingFound.common.title: 没有或不足的数据显示
§ uiKit.nothingFound.common.description: 如果提交以该格式签名，系统将处理更多数据 [Git commit message convention|https://www.conventionalcommits.org/en/v1.0.0/]. 模型:
§ uiKit.nothingFound.common.console: 发行编号类别(功能): 解释说明
§ uiKit.nothingFound.common.example: 例如:
§ uiKit.nothingFound.staff.title: 没有这个员工的数据
§ uiKit.nothingFound.staff.description1
他不每天工作，所以获得了“助理”职务。
可以不考虑带有这种职称的员工的统计数据。他的贡献很小。
§ uiKit.nothingFound.staff.description2
系统不会为其计算若干指标。
如果这是一个错误，并且需要考虑这个员工的数据，请转到“设置”部分并更改他的类型。
§ common.title: Git 统计数字
§ common.filters: 过滤器
§ common.notifications.save: 将保存更改
§ common.notifications.setting: 设置被保存
§ common.fileLoader.notification: Cant open file $1
`;
